import { render } from "./Batch_Readings.vue?vue&type=template&id=274c81f2"
import script from "./Batch_Readings.vue?vue&type=script&lang=js"
export * from "./Batch_Readings.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__